import { setToken, removeToken, getToken } from '@/utils/auth'

// 从localStorage获取初始状态
// 根据当前 URL判断是否为管理员页面
const isAdminPage = window.location.href.includes('/admin');
const token = getToken(isAdminPage ? 'admin' : 'user');
const userInfoStr = localStorage.getItem('userInfo')
const userInfo = userInfoStr ? JSON.parse(userInfoStr) : null

// 获取保存的登录数据
const loginDataStr = localStorage.getItem('loginData')
const loginData = loginDataStr ? JSON.parse(loginDataStr) : null


export default {
  namespaced: true,
  state: {
    token: token || null,
    userInfo: userInfo || null,
    loginData: loginData || null // 存储完整的登录响应数据
  },
  getters: {
    isLoggedIn: state => {
      // 根据当前URL判断是否为管理员页面
      const isAdminPage = window.location.href.includes('/admin');
      // 如果state.token为null，则检查localStorage中是否有对应类型的token
      return !!state.token || !!getToken(isAdminPage ? 'admin' : 'user');
    },
    userInfo: state => state.userInfo || {},
    loginData: state => {
      // 如果state中没有loginData，尝试从localStorage获取
      if (!state.loginData) {
        const storedData = localStorage.getItem('loginData');
        return storedData ? JSON.parse(storedData) : null;
      }
      return state.loginData;
    }
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
      // 保存用户信息到localStorage
      if (userInfo) {
        localStorage.setItem('userInfo', JSON.stringify(userInfo))
      } else {
        localStorage.removeItem('userInfo')
      }
    },
    SET_LOGIN_DATA(state, data) {
      state.loginData = data
      // 保存完整登录数据到localStorage
      if (data) {
        localStorage.setItem('loginData', JSON.stringify(data))
      } else {
        localStorage.removeItem('loginData')
      }
    },
    CLEAR_USER_STATE(state) {
      state.token = null
      state.userInfo = null
      state.loginData = null
    }
  },
  actions: {
    login({ commit, dispatch }, { token, userInfo, loginData }) {
      console.log('登录操作:', { token, userInfo, loginData })
      // 判断是否为管理员登录
      // 由于接口返回数据中没有用户角色信息，只能根据当前URL判断
      const isAdmin = window.location.href.includes('/admin');
      const tokenType = isAdmin ? 'admin' : 'user';
      
      console.log('登录类型:', tokenType, '是否为管理员页面:', isAdmin);
      
      // 持久化存储token，同时存储到两种类型
      // 这样无论在哪个页面都能访问到token
      setToken(token, 'admin') // 存储为管理员token
      setToken(token, 'user')  // 同时也存储为用户token
      commit('SET_TOKEN', token)
      
      // 如果有userInfo，则存储
      if (userInfo) {
        commit('SET_USER_INFO', userInfo)
      } else {
        // 如果没有userInfo，则创建一个基本的userInfo对象
        // 不再区分角色，统一设置为通用角色
        commit('SET_USER_INFO', { role: 'user' })
      }
      
      // 存储完整的登录响应数据
      if (loginData) {
        commit('SET_LOGIN_DATA', loginData)
      }
      
      // 触发全局状态更新
      setTimeout(() => {
        dispatch('forceUpdate', null, { root: true })
      }, 0)
    },
    // 获取用户信息
    async getUserInfo({ commit }) {
      try {
        console.log('获取用户信息')
        // 导入getUserInfo API
        const { getUserInfo } = await import('@/api/adminapi/admin')
        const res = await getUserInfo()
        
        console.log('获取用户信息结果:', res)
        
        if (res.code === 200 && res.data) {
          // 更新用户信息
          commit('SET_USER_INFO', res.data)
          return res.data
        } else {
          console.error('获取用户信息失败:', res.data || '未知错误')
          return null
        }
      } catch (error) {
        console.error('获取用户信息出错:', error)
        return null
      }
    },
    logout({ commit, dispatch }) {
      console.log('登出操作')
      
      // 移除所有类型的token
      removeToken('admin')
      removeToken('user')
      
      localStorage.removeItem('userInfo') // 确保移除localStorage中的用户信息
      localStorage.removeItem('loginData') // 确保移除localStorage中的登录数据
      commit('CLEAR_USER_STATE')
      
      // 触发全局状态更新
      setTimeout(() => {
        dispatch('forceUpdate', null, { root: true })
      }, 0)
    }
  }
}